import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { DateTime, Duration, DurationLikeObject } from 'luxon';

@Directive({
    selector: '[mmShortHandParser]',
    standalone: true,
    exportAs: 'mmShortHandParser'
})
export class ShortHandParserDirective {
    @Input('mmShortHandParser') shortHandParser: boolean | undefined;
    @Output() updateDate = new EventEmitter<DateTime>();
    shortHandPromise: ReturnType<typeof setTimeout> | null = null;
    pattern = /([dwmy])\+(\d+)/i;

    @HostListener('input', ['$event.target.value']) onChange(v: string) {
        this.validateShortHand(v);
    }

    constructor() {
        // NOOP
    }

    getModifier(m: string, amt: number): DurationLikeObject {
        switch (m) {
            case 'w': {
                return { 'weeks': amt } as DurationLikeObject;
            }
            case 'm': {
                return { 'months': amt } as DurationLikeObject;
            }
            case 'y': {
                return { 'years': amt } as DurationLikeObject;
            }
            default: {
                return { 'days': amt } as DurationLikeObject;
            }
        }
    }

    buildDate(amount: number | string, modifier: string): void {
        const date = DateTime.now().plus(
            Duration.fromObject(this.getModifier(modifier, amount as number)));
        this.updateDate.emit(date);
    }


    validateShortHand(value: string): void {
        const match = this.pattern.exec(value ?? '');
        if (match) {
            if (this.shortHandPromise) {
                window.clearTimeout(this.shortHandPromise);
            }
            this.shortHandPromise = setTimeout(() => {
                this.buildDate(match[ 2 ], match[ 1 ]);
            }, 500);
            return;
        }
    }

}
